<template>
  <v-skeleton-loader class="mx-auto" :loading="loading" type="card-heading">
    <v-card outlined>
      <v-card-title>
        <div class="flex-grow-1">{{ this.propertyCount - 1 }} Diagnostic Condition(s)</div>
      </v-card-title>
      <div class="d-flex flex-wrap align-content-start px-1 pb-2">
        <div v-if="key !== '_id'" v-for="(value, key, index) in reportData[0]" v-bind:key="index">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                dark
                v-bind="attrs"
                v-on="on"
                v-bind:key="reportData[0][key]"
                class="chip-style ma-2"
              >{{ formatWord(key) }}</v-chip>
            </template>
            <span>{{ value }}</span>
          </v-tooltip>
        </div>
      </div>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import axios from 'axios';

export default {
  name: 'DiagnosticSummary',
  props: [
    'value',
    'patientID',
    'organizations',
    'insurance',
    'startDate',
    'endDate',
    'providers',
    'groups',
    'locations',
  ],
  data() {
    return {
      loading: false,
      dialog: false,
      reportData: [],
      fireReport: false,
      propertyCount: 0,
    };
  },
  created() {
    this.getReport();
  },
  methods: {
    async getReport() {
      const { startDate } = this;
      const { patientID } = this;
      const { endDate } = this;
      const { insurance } = this;
      const organizations = this.organization;
      const { groups } = this;
      const provNums = this.providers;
      const locs = this.locations;

      let providers = [];
      let locations = [];

      if (provNums.length > 0) {
        provNums.forEach((prov) => {
          if (providers.indexOf(prov.Center_PCP_Number) === -1) {
            providers.push(prov.Center_PCP_Number);
          }
        });
      } else {
        providers = [];
      }

      if (locs.length > 0) {
        locs.forEach((loca) => {
          if (locations.indexOf(loca.Center_Location) === -1) {
            locations.push(loca.Center_Location);
          }
        });
      } else {
        locations = [];
      }

      // Check for pending request and if so cancel old one for new incoming
      this.cancelSearch();
      // Set the CancelToken
      this.cancelSource = axios.CancelToken.source();

      if (insurance.length !== 0) {
        this.loading = true;
        this.reportData = [];
        const response = axios
          .get(
            `api/ai/modal/diagnosissummary/orgs=${organizations}/groups=${groups}/providers=${providers}/locs=${locations}/${insurance}/${startDate}/${endDate}/${patientID}`,
            { cancelToken: this.cancelSource.token },
          )
          .then((response) => {
            this.reportData = response.data;
            this.propertyCount = 0;
            for (const num in this.reportData[0]) {
              this.propertyCount += 1;
            }

            this.cancelSource = null;
            this.loading = false;
          });
      }
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
    formatWord(phrase) {
      return phrase
        .toLowerCase()
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
  },

  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    // Watch every dropdown and run report again on change
    async groups() {
      this.getReport();
    },
    async providers() {
      this.getReport();
    },
    async locations() {
      this.getReport();
    },
    async startDate() {
      this.getReport();
    },
    async endDate() {
      this.getReport();
    },
    async patientID() {
      this.getReport();
    },
  },
};
</script>

<style>
.code-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
